module.exports = __webpack_public_path__ + "img/bulb-green.d029a127.svg";